import SortIcon from "../common/SortIcon";
import React from "react";
const TableHeaderCell = _ref => {
  let {
    columnKey,
    tooltip,
    onClick,
    headerValue,
    sorting
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "header-cell flex ".concat(columnKey, "-grid")
  }, tooltip && tooltip, /*#__PURE__*/React.createElement("div", {
    className: "item-cell",
    onClick: onClick ? () => onClick(columnKey) : undefined
  }, /*#__PURE__*/React.createElement("span", {
    className: "header-value"
  }, headerValue), sorting && /*#__PURE__*/React.createElement("span", {
    className: "wrap-icons"
  }, /*#__PURE__*/React.createElement(SortIcon, sorting))));
};
export default TableHeaderCell;